import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ColorSchemeToggleProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export default function ColorSchemeToggle({
  onClick,
  className,
}: ColorSchemeToggleProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button
        variant="outline"
        size="icon-sm"
        className={cn(className)}
        disabled
      />
    );
  }

  return (
    <Button
      id="toggle-mode"
      variant="outline"
      size="icon-sm"
      className={cn(className)}
      onClick={(event) => {
        if (theme === "light") {
          setTheme("dark");
        } else {
          setTheme("light");
        }
        onClick?.(event);
      }}
    >
      {theme === "light" ? (
        <Moon className="size-4" />
      ) : (
        <Sun className="size-4" />
      )}
    </Button>
  );
}
